/*
 *
 * ReportsPage reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingDimensions: true,
  dimensionsDrillDown: [],
  teams: [],
})

function widgetResultByDimensionTeamReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIMENSIONS_WATCHER:
      return state
        .set("isLoadingDimensions", true)
        .set("dimensionsDrillDown", [])
        .set("teams", [])

    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoadingDimensions", false)
        .set("dimensionsDrillDown", action.payload.dimensions_drill_down)
        .set("teams", action.payload.teams)

    case GET_DIMENSIONS_FAILED:
      return state
        .set("isLoadingDimensions", false)
        .set("dimensionsDrillDown", [])
        .set("teams", [])

    default:
      return state
  }
}

export default widgetResultByDimensionTeamReducer
